/* eslint no-undef: 0 */
export const commitRef = function commitRef() {
  return String(COMMIT_REF).substr(0, 8);
};

export const isDevCommit = function isDevCommit() {
  return commitRef() === 'dev';
};
